<style lang="stylus">
    .insertTable-mask
        .insertTable-modal
            width 304px
            .insertTable-container
                padding 15px 0px
                .insertTable-blocktitle
                    float left
                    width 60px
                    max-width 80px
                    font-size 12px
                    overflow hidden
                    white-space nowrap
                    text-overflow ellipsis
                .insertTable-top-box
                    height 24px
                    margin 0 0 16px 0
                    display flex
                    justify-content space-between
                    line-height 24px
                    .insertTable-topline
                        display flex
                        .ivu-input-number
                            width 64px
                            .ivu-input-number-handler-wrap, .ivu-input-number-input
                                background-color var(--bg-color-tertiary)
                        .insertTable-linetitle
                            font-size 12px
                            margin-right 8px
                .insertTable-bottom-box
                    overflow hidden
                    .insertTable-bottom-leftbox
                        float left
                        width 140px
                        .switch-block
                            margin-bottom 20px
                            height 20px
                            white-space: nowrap

                            .switch-btn
                                float left
                                position relative
                                width 30px
                                height 16px
                                border-radius 20px
                                background-color #aaa
                                margin-top 2px
                                cursor pointer
                                user-select none
                                &:after
                                    content ''
                                    position absolute
                                    width 12px
                                    height 12px
                                    border-radius 50%
                                    background-color #fff
                                    top 2px
                                    left 3px
                                    transition left .1s linear
                            .switch-btn.active
                                background-color #3686ea
                                &:after
                                    background-color #fff
                                    left 15px
                            .switch-text
                                float left
                                line-height 20px
                                margin-left 12px
                    .insertTable-bottom-rightbox
                        float left
                        width 114px
                        padding-left 20px
                        .tableset_colorbtn
                            position relative
                            width 100%
                            height 24px
                            margin-bottom 16px
                            display flex
                            align-items center
                            justify-content flex-end
                            .tableset_colorbtn_colorbox
                                colorbtn()
                                width 20px
                                height 20px
</style>

<template>
    <div class="insertTable-mask">
        <Dialog
            class="insertTable-modal"
            :title="$t('InsertTable.title')"
            :mask="true"
            :showFooter="true"
            :isShow="true"
            @ok="createTable"
            @close="closeModal"
        >
            <div class="insertTable-container">
                <div class="insertTable-top-box">
                    <!-- <p class="insertTable-blocktitle" :title="$t('InsertTable.toptitle')">
                        {{$t('InsertTable.toptitle')}}
                    </p> -->
                    <div class="insertTable-topline">
                        <p class="insertTable-linetitle">
                            {{ $t("InsertTable.row") }}
                        </p>
                        <InputNumber @on-change="checkNum(0)" :min="1" :max="100" :step="1" size="small" v-model="rowNum" />
                    </div>
                    <div class="insertTable-topline">
                        <p class="insertTable-linetitle">
                            {{ $t("InsertTable.column") }}
                        </p>
                        <InputNumber @on-change="checkNum(1)" :min="1" :max="100" :step="1" size="small" v-model="columnNum" />
                    </div>
                </div>
                <div class="insertTable-bottom-box" v-if="false">
                    <p class="insertTable-blocktitle">
                        {{ $t("InsertTable.bottomtitle") }}
                    </p>
                    <div class="insertTable-bottom-leftbox">
                        <div class="switch-block" v-for="(item, index) in fillList" :key="index" @click.prevent="setClick(index)">
                            <Checkbox class="" v-model="$store.state.table.createTableFill[index]">{{ $t(item.name) }}</Checkbox>
                        </div>
                    </div>
                    <div class="insertTable-bottom-rightbox">
                        <div class="tableset_colorbtn">
                            <div
                                class="tableset_colorbtn_colorbox"
                                :style="{ backgroundColor: $store.state.table.createTableFillColor[0] }"
                                :class="$store.state.table.createTableFill[0] ? '' : 'color-ban'"
                                @click="showTopColor($event)"
                            ></div>
                        </div>
                        <div class="tableset_colorbtn">
                            <div
                                class="tableset_colorbtn_colorbox"
                                :style="{ backgroundColor: $store.state.table.createTableFillColor[1] }"
                                :class="$store.state.table.createTableFill[1] || $store.state.table.createTableFill[2] ? '' : 'color-ban'"
                                @click="showRowColor($event)"
                            ></div>
                        </div>
                        <div class="tableset_colorbtn">
                            <div
                                class="tableset_colorbtn_colorbox"
                                :style="{ backgroundColor: $store.state.table.createTableFillColor[2] }"
                                :class="$store.state.table.createTableFill[1] || $store.state.table.createTableFill[2] ? '' : 'color-ban'"
                                @click="showColumnColor($event)"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="insertTable-right-box" v-if="false">
                    <div class="tableset_contentbox" style="margin-top: 15px">
                        <div
                            class="tableset_imgbtn"
                            v-for="(item, index) in fillList"
                            :key="index"
                            :class="{ active: $store.state.table.createTableFill[index] }"
                        >
                            <iconSymbol class="item-icon" :name="item.name" @click.native="setClick(index)"></iconSymbol>
                            <div class="box-checkbox" @click="setClick(index)"></div>
                        </div>
                        <div class="tableset_text">
                            <p>{{ $t("InsertTable.showColorText_title") }}</p>
                            <p>{{ $t("InsertTable.showColorText_alter") }}</p>
                        </div>
                        <div class="tableset_colorbtn">
                            <div class="tableset_colorbtn_colorbox" @click.stop="showTopColor($event)">
                                <div
                                    class="tableset_colorbtn_color"
                                    :class="{ white: $store.state.table.createTableFillColor[0] == '#ffffff' }"
                                    :style="{ backgroundColor: $store.state.table.createTableFillColor[0] }"
                                ></div>
                            </div>
                        </div>
                        <div class="tableset_colorbtn">
                            <div class="tableset_colorbtn_colorbox" @click.stop="showRowColor($event)">
                                <div
                                    class="tableset_colorbtn_color"
                                    :class="{ white: $store.state.table.createTableFillColor[1] == '#ffffff' }"
                                    :style="{ backgroundColor: $store.state.table.createTableFillColor[1] }"
                                ></div>
                            </div>
                        </div>
                        <div class="tableset_colorbtn">
                            <div class="tableset_colorbtn_colorbox" @click.stop="showColumnColor($event)">
                                <div
                                    class="tableset_colorbtn_color"
                                    :class="{ white: $store.state.table.createTableFillColor[2] == '#ffffff' }"
                                    :style="{ backgroundColor: $store.state.table.createTableFillColor[2] }"
                                ></div>
                            </div>
                        </div>
                        <div class="tableset_text2">
                            <p>{{ $t("InsertTable.colorText_title") }}</p>
                            <p>{{ $t("InsertTable.colorText_alter") }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class InsertTable extends Vue {
        rowNum: number = 5;
        columnNum: number = 3;
        fillList: Array<object> = [
            {
                title: "",
                name: "InsertTable.top-fill",
            },
            {
                title: "",
                name: "InsertTable.row-fill",
            },
            {
                title: "",
                name: "InsertTable.column-fill",
            },
        ];
        timer: number = 0;
        lock: boolean = true;
        setClick(index) {
            if (index == 0) {
                this.$store.commit("setTableFill", { type: "top", target: "create" });
            } else if (index == 1) {
                this.$store.commit("setTableFill", { type: "row", target: "create" });
            } else if (index == 2) {
                this.$store.commit("setTableFill", { type: "column", target: "create" });
            }
        }
        showTopColor(e) {
            if (!this.$store.state.table.createTableFill[0]) return;
            let node = e.target;
            let payload = {
                type: this.fmtType.table,
                index: 10,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "TopFillColor" });
            });
        }
        showRowColor(e) {
            if (!(this.$store.state.table.createTableFill[1] || this.$store.state.table.createTableFill[2])) return;
            let node = e.target;
            let payload = {
                type: this.fmtType.table,
                index: 11,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "RowFillColor" });
            });
        }
        showColumnColor(e) {
            if (!(this.$store.state.table.createTableFill[1] || this.$store.state.table.createTableFill[2])) return;
            let node = e.target;
            let payload = {
                type: this.fmtType.table,
                index: 12,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "ColumnFillColor" });
            });
        }
        closeModal() {
            this.rowNum = 0;
            this.columnNum = 0;
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.$store.commit("setTableFill", { type: "reset", target: "create" });
            this.$store.commit("setTableFillColor", { type: "reset", target: "create" });
        }
        createTable() {
            if (!this.lock) return;
            let colorList = this.$store.state.table.createTableFillColor;
            let stateList = this.$store.state.table.createTableFill;
            let view = window["_view"];
            view.insertTable(Math.round(this.rowNum), Math.round(this.columnNum));
            view.setClrButtons(stateList);
            view.setButtonsSelectClrs(colorList);
            view.updateTableFillClr();
            if (view._activeShape) {
                view.updateRightTable(view._activeShape);
                view._activePage.update(view._activeShape.outline2());
                if (!view._activePage.extendPageBreaks()) view.invalidate();
            }
            this.closeModal();
        }
        checkNum(index) {
            this.lock = false;
            if (!!index) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.columnNum = this.columnNum < 1 ? 1 : Math.round(this.columnNum) > 100 ? 100 : Math.round(this.columnNum);
                    this.lock = true;
                }, 500);
            } else {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.rowNum = this.rowNum < 1 ? 1 : Math.round(this.rowNum) > 100 ? 100 : Math.round(this.rowNum);
                    this.lock = true;
                }, 500);
            }
        }
        mounted() {}
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "InsertTable": {
      "title": "插入表格",
      "toptitle": "单元格数",
      "bottomtitle": "颜色",
      "row": "行",
      "column": "列",
      "confirm": "确定",
      "cancel": "取消",
      "top-fill": "表头",
      "row-fill": "水平交替",
      "column-fill": "垂直交替",
      "top-color": "标题色",
      "change-color": "交替色"
    }
  },
  "en": {
    "InsertTable": {
      "title": "Insert Table",
      "toptitle": "Table Size",
      "bottomtitle": "Color",
      "row": "Rows",
      "column": "Columns",
      "confirm": "Insert",
      "cancel": "Cancel",
      "top-fill": "Header",
      "row-fill": "Alternate Rows",
      "column-fill": "Alternate Columns",
      "top-color": "Title Color",
      "change-color": "Alternate Color"
    }
  },
  "fr": {
    "InsertTable": {
      "title": "Insérer Tableau",
      "toptitle": "Nombre de Cellules",
      "bottomtitle": "Couleur",
      "row": "Ligne",
      "column": "Colonne",
      "confirm": "Confirmer",
      "cancel": "Annuler",
      "top-fill": "Titre",
      "row-fill": "Alternant Horizontalement",
      "column-fill": "Alternance Verticale",
      "top-color": "Couleur du Titre",
      "change-color": "Couleurs Alternatives"
    }
  },
  "de": {
    "InsertTable": {
      "title": "Tabelle einfügen",
      "toptitle": "Tabellengröße",
      "bottomtitle": "Farbe",
      "row": "Zeilen",
      "column": "Spalten",
      "confirm": "Sichern",
      "cancel": "Abbrechen",
      "top-fill": "Titel",
      "row-fill": "Alternative Zeilen",
      "column-fill": "Alternative Spalten",
      "top-color": "Titelfarbe",
      "change-color": "Alternative Farbe"
    }
  },
  "jp": {
    "InsertTable": {
      "title": "表を挿入",
      "toptitle": "セルの数量",
      "bottomtitle": "色",
      "row": "行",
      "column": "列",
      "confirm": "OK",
      "cancel": "キャンセル",
      "top-fill": "タイトル",
      "row-fill": "水平交替",
      "column-fill": "垂直交替",
      "top-color": "タイトルの色",
      "change-color": "交替色"
    }
  },
  "es": {
    "InsertTable": {
      "title": "Insertar tabla",
      "toptitle": "Tamaño de la mesa",
      "bottomtitle": "Color",
      "row": "Filas",
      "column": "Columnas",
      "confirm": "Insertar",
      "cancel": "Cancelar",
      "top-fill": "Título",
      "row-fill": "Filas alternas",
      "column-fill": "Columnas alternas",
      "top-color": "Color del título",
      "change-color": "Color alternativo"
    }
  },
  "pt": {
    "InsertTable": {
      "title": "Inserir Tabela",
      "toptitle": "Tamanho da Tabela",
      "bottomtitle": "Cor",
      "row": "Linhas",
      "column": "Colunas",
      "confirm": "Inserir",
      "cancel": "Cancelar",
      "top-fill": "Título",
      "row-fill": "Alternar Linhas",
      "column-fill": "Alternar Colunas",
      "top-color": "Cor do Título",
      "change-color": "Alternar Cor"
    }
  },
  "it": {
    "InsertTable": {
      "title": "Inserisci Tabella",
      "toptitle": "Dimensione Tabella",
      "bottomtitle": "Colore",
      "row": "Righe",
      "column": "Colonne",
      "confirm": "Inserisci",
      "cancel": "Annulla",
      "top-fill": "Titolo",
      "row-fill": "Righe Alternate",
      "column-fill": "Colonne Alternate",
      "top-color": "Colore Titolo",
      "change-color": "Colore Alternato"
    }
  },
  "tw": {
    "InsertTable": {
      "title": "插入表格",
      "toptitle": "單元格數",
      "bottomtitle": "顏色",
      "row": "行",
      "column": "列",
      "confirm": "確定",
      "cancel": "取消",
      "top-fill": "表頭",
      "row-fill": "水平交替",
      "column-fill": "垂直交替",
      "top-color": "標題色",
      "change-color": "交替色"
    }
  },
  "kr": {
    "InsertTable": {
      "title": "표 삽입",
      "toptitle": "표 크기",
      "bottomtitle": "색깔 ",
      "row": "행",
      "column": "열",
      "confirm": "확인 ",
      "cancel": "취소 ",
      "top-fill": "헤더",
      "row-fill": "수평 교체",
      "column-fill": "수직 교체",
      "top-color": "제목 색깔",
      "change-color": "교체 색깔"
    }
  }
}
</i18n>
